var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center"},[_c('v-switch',{attrs:{"input-value":_vm.value.auto_accept_enabled,"dense":""},on:{"change":_vm.onchange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }